/* eslint-disable no-underscore-dangle -- Internal rendering context shared with the backend. */
export const appointmentMessages = {
  ru: {
    valueExample: 'ПО;ТО',
    preparation: 'Подготовка к приёму',
    insertVariable: 'Вставить переменную…',
    before: 'До изменения',
    after: 'После изменения',
    daily: 'Приёмы за день и подготовка',
    other: 'Филиал, ссылки и другие данные',
    preparationHint:
      'Добавьте в текст переменную «Подготовка». Значения разделяются точкой с запятой; порядок не важен. Общие инструкции не повторяются.',
    addRule: 'Добавить инструкцию',
    removeRule: 'Удалить инструкцию',
    parameter: 'Выберите параметр',
    condition: 'Условие',
    patient: 'Пациент',
    appointment: 'Запись на приём',
    appointment_service: 'Товары записи на приём',
    values: 'Значения через точку с запятой',
    all: 'Содержит все значения',
    any: 'Содержит хотя бы одно',
    append: 'Добавить инструкцию',
    replace: 'Заменить инструкции этой группы',
    common: 'Общая подготовка',
    specific: 'Только для этого приёма',
    text: 'Текст инструкции',
    replacementHint:
      'Замена действует внутри выбранной группы. Из совпавших замен приоритет у комбинации с наибольшим числом значений.',
    examples: 'Проверить на примере',
    single: 'Один приём',
    moved: 'Перенос',
    day: 'Два приёма за день',
    missing: 'Без ФИО врача',
    sampleValue: 'Значение для примера',
    sampleValue2: 'Значение во втором приёме',
    missingVariables: 'Отправка заблокирована: не заполнены переменные',
    fieldsFailed:
      'Не удалось загрузить параметры. Повторите открытие редактора.',
    purpose: 'Назначение сообщения',
    notification: 'Сообщение по записи',
    reminder: 'Напоминание о предстоящем приёме',
    change: 'Уведомление об изменении',
    cancellation: 'Уведомление об отмене',
    grouping: 'Как объединять записи',
    separately: 'Отдельно по каждой записи',
    together: 'Одно напоминание на пациента за день',
    groupingHint:
      'Для запуска по расписанию. Собираются будущие активные приёмы за день исходной записи, прошедшие условия этой ветки. Один источник сообщений — одно напоминание. Используйте «Приёмы.Список» и «Подготовка».',
    changes: 'Отправлять при изменении',
    dateTime: 'Даты или времени',
    doctor: 'Специалиста',
    branch: 'Филиала',
    changeHint:
      'Для события «Изменена запись». Используйте переменные «Приём.До.…» и «Приём.После.…». Устаревший перенос не отправляется.',
    invalid_preparation_rules:
      'Проверьте поле, значения и текст каждой инструкции.',
    invalid_message_purpose: 'Выберите назначение сообщения.',
    invalid_appointment_mode: 'Выберите способ объединения записей.',
    invalid_change_fields: 'Выберите хотя бы одно поле изменения.',
    change_requires_updated_event:
      'Уведомление об изменении требует события обновления записи.',
    previous_tokens_require_change:
      'Переменные «До/После» требуют назначения «Уведомление об изменении».',
    patient_day_requires_schedule:
      'Объединение приёмов доступно при запуске по расписанию для записей на приём.',
    patient_day_requires_reminder:
      'Для объединения выберите назначение «Напоминание».',
    patient_day_requires_accepted:
      'Для общего напоминания результат — сообщение принято каналом.',
    patient_day_no_actions:
      'В общем напоминании нельзя использовать календарь и действия, относящиеся к одному приёму.',
    patient_day_list_required:
      'Добавьте в общий шаблон переменную «Приёмы.Список».',
    patient_day_single_tokens:
      'В общем шаблоне используйте список приёмов вместо времени, врача и филиала одной записи.',
  },
  en: {
    valueExample: 'A;B',
    preparation: 'Appointment preparation',
    insertVariable: 'Insert a variable…',
    before: 'Before change',
    after: 'After change',
    daily: 'Daily appointments and preparation',
    other: 'Branch, links and other details',
    preparationHint:
      'Insert the Preparation variable in the text. Separate values with semicolons; order does not matter. Common instructions are deduplicated.',
    addRule: 'Add instruction',
    removeRule: 'Remove instruction',
    parameter: 'Choose a parameter',
    condition: 'Condition',
    patient: 'Patient',
    appointment: 'Appointment',
    appointment_service: 'Appointment services',
    values: 'Semicolon-separated values',
    all: 'Contains all values',
    any: 'Contains any value',
    append: 'Add instruction',
    replace: 'Replace instructions in this group',
    common: 'Common preparation',
    specific: 'This appointment only',
    text: 'Instruction text',
    replacementHint:
      'Replacement applies within its group. Matching replacements with the most values take priority.',
    examples: 'Preview an example',
    single: 'One appointment',
    moved: 'Rescheduled',
    day: 'Two appointments in a day',
    missing: 'Missing doctor name',
    sampleValue: 'Sample value',
    sampleValue2: 'Second appointment value',
    missingVariables: 'Sending blocked: missing variables',
    fieldsFailed: 'Could not load parameters. Reopen the editor.',
    purpose: 'Message purpose',
    notification: 'Appointment message',
    reminder: 'Upcoming appointment reminder',
    change: 'Change notification',
    cancellation: 'Cancellation notification',
    grouping: 'Appointment grouping',
    separately: 'One message per appointment',
    together: 'One daily reminder per patient',
    groupingHint:
      'Scheduled starts only. Includes future active appointments on the source appointment date that match this branch. One source per reminder. Use Appointment list and Preparation.',
    changes: 'Send when changed',
    dateTime: 'Date or time',
    doctor: 'Specialist',
    branch: 'Branch',
    changeHint:
      'Requires an appointment update event. Use Before/After variables. Superseded changes are not sent.',
    invalid_preparation_rules: 'Check each instruction field, values and text.',
    invalid_message_purpose: 'Select a message purpose.',
    invalid_appointment_mode: 'Select appointment grouping.',
    invalid_change_fields: 'Select at least one changed field.',
    change_requires_updated_event:
      'Change notifications require an updated event.',
    previous_tokens_require_change:
      'Before/After variables require a change notification.',
    patient_day_requires_schedule:
      'Grouped reminders require scheduled appointment starts.',
    patient_day_requires_reminder:
      'Select reminder purpose for grouped messages.',
    patient_day_requires_accepted:
      'Grouped reminders require an accepted result.',
    patient_day_no_actions:
      'Grouped reminders cannot contain single-appointment calendars or actions.',
    patient_day_list_required: 'Insert the appointment list variable.',
    patient_day_single_tokens:
      'Use the appointment list instead of single appointment fields.',
  },
};

export const eventTokens = ['До', 'После'].flatMap(prefix =>
  ['Дата', 'Время', 'Врач', 'Филиал', 'Адрес'].map(
    field => `Приём.${prefix}.${field}`
  )
);

export const messageValidationMessages = Object.fromEntries(
  Object.entries(appointmentMessages).map(([locale, messages]) => [
    locale,
    Object.fromEntries(
      Object.entries(messages).filter(([key]) =>
        /^(invalid_|patient_day_|previous_tokens_|change_requires_)/.test(key)
      )
    ),
  ])
);

export const tokenGroup = token => {
  if (token.startsWith('Пациент.')) return 'patient';
  if (token.startsWith('Приём.До.')) return 'before';
  if (token.startsWith('Приём.После.')) return 'after';
  if (token.startsWith('Приёмы.') || token === 'Подготовка') return 'daily';
  if (token.startsWith('Приём.') || token.startsWith('Врач'))
    return 'appointment';
  return 'other';
};

// Synthetic data only. Neither preview path creates records or sends messages.
export const appointmentPreview = (vars, example, rules, samples) => {
  const result = { ...vars };
  const context = second => {
    const data = { patient: {}, appointment: {}, appointment_service: [{}] };
    rules.forEach(rule => {
      const key = `${rule.context}.${rule.field}`;
      const target =
        rule.context === 'appointment_service'
          ? data.appointment_service[0]
          : data[rule.context];
      if (target && rule.field)
        target[rule.field] =
          samples[key]?.[second && rule.context !== 'patient' ? 1 : 0] ??
          'ПО;ТО';
    });
    return data;
  };
  result._context = context(false);
  if (example === 'missing') result.Врач = '';
  if (example === 'moved') {
    ['Дата', 'Время', 'Врач', 'Филиал', 'Адрес'].forEach(field => {
      const key = {
        Дата: 'Приём.Дата',
        Время: 'Приём.Время',
        Врач: 'Врач',
        Филиал: 'Филиал',
        Адрес: 'Филиал.Адрес',
      }[field];
      result[`Приём.До.${field}`] =
        field === 'Дата' ? '18.09.2026' : result[key];
      result[`Приём.После.${field}`] =
        field === 'Дата' ? '19.09.2026' : result[key];
    });
    result['Приём.Дата'] = '19.09.2026';
  }
  if (example === 'day') {
    result._appointments = [
      { vars: { ...result }, context: context(false) },
      {
        vars: {
          ...result,
          'Приём.Время': '11:30',
          Врач: 'Иванова Анна Сергеевна',
        },
        context: context(true),
      },
    ];
    [
      'Приём.Время',
      'Врач',
      'Врач.Кратко',
      'Филиал',
      'Филиал.Адрес',
      'Филиал.Маршрут',
      'Стадия',
    ].forEach(key => delete result[key]);
  }
  return result;
};
